import {ButtonTheme as ButtonThemes} from 'common/components/button/constants';

export const THEME = {
  PRIMARY: `primary`,
  SECONDARY: `secondary`,
  BUILDER: `builder`,
  ...ButtonThemes,
};

export const TRACKING_EVENTS = {
  HOVER_CONTEXT_PANEL: `Context panel hover`,
  LEXICON_TAG_SELECTED: `[Lexicon] Select Report Events Tag`,
  LEXICON_SHOW_HIDDEN: `[Lexicon] Show Hidden Entities`,
  EDIT_DESCRIPTION: `Edit Description`,
  SAMPLE_EVENT: `Viewed Sample Event`,
};

export const SELECTOR_TYPE = {
  TEXT: `text`,
  BUTTON: `button`,
};

export const MAX_LABEL_LENGTH = 115;
